import React from 'react';
import Favicon from 'react-favicon';
import './App.css';
import Login from './pages/Login';
import Index from './pages/Index';
import { Form } from '@ant-design/compatible';
//import '@ant-design/compatible/assets/index.css';

import { getLanguage } from 'react-multi-lang'
import { ConfigProvider } from 'antd';
import ca from 'antd/es/locale/ca_ES';
import es from 'antd/es/locale/es_ES';
import en from 'antd/es/locale/en_GB';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';
import 'moment/locale/en-gb';

import { PerfilUsuariProvider } from "./context/perfil-usuari";
import { MenuTriatProvider } from "./context/menu-triat";


const FormLogin = Form.create({ name: 'normal_login' })(Login);

class App extends React.Component{
    constructor() {
      super();
      if (process.env.NODE_ENV !== "production"){
        this.state = {
          login: false
        }
      }else{
        this.state = {
          login: false
        }
      }

    }
/*
// prevenir enrera button
    handleWindowClose = (ev) => {
            ev.preventDefault();
            return ev.returnValue = 'Leaving this page will loose data';
    }

    onBackButtonEvent = (e) => {
        e.preventDefault();
        window.history.forward();
    }
    componentDidMount = () => {
      if (process.env.NODE_ENV === "production"){
        window.addEventListener('beforeunload',this.handleWindowClose);
        window.addEventListener('popstate',this.onBackButtonEvent);
      }
    }
    componentWillUnmount = () => {
      if (process.env.NODE_ENV === "production"){
        window.removeEventListener('beforeunload',this.handleWindowClose);
        window.removeEventListener('popstate',this.onBackButtonEvent);
      }
    }
// FI prevenir enrera button
*/
    changeLogin = () =>{
      this.setState({login: !this.state.login});
    }
    logOut = () =>{
      this.setState({login: false});
    }

    render(){
      moment.locale('ca');
      let language = getLanguage();
      const lang = sessionStorage.getItem('Language');
      if(lang){
        //language = lang==="ca"?ca:es;
        switch (lang) {
          case "ca":
            language=ca;
            break;
          case "es":
            language=es;
            break;
          case "en":
            language=en;
            break;
          default:
            language=es;
        }
      }


      let url_favicon = "favicon.png";
/*
      switch (global.app_id) {
        case "british":
            url_favicon='https://britishcostadaurada.com/img/favicon.png';
          break;
        case "aquamora":
            url_favicon='https://model6.netagencias.com/images/favicon.png';
          break;
        default:
          url_favicon ='/favicon.ico';
      }*/


      return (
        <PerfilUsuariProvider>
          <MenuTriatProvider>
            <ConfigProvider locale={language}>
            <Favicon url={url_favicon} />
              <div style={{backgroundColor: '#e0e0e0'}}>
                { this.state.login ? <Index logout={this.logOut}/> : <FormLogin callback={this.changeLogin} className="App"/>}
              </div>
            </ConfigProvider>
          </MenuTriatProvider>
        </PerfilUsuariProvider>
    );
  }
}

export default App;
